"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");
/* eslint-disable */


var copy_to_clipboard_1 = tslib_1.__importDefault(require("copy-to-clipboard"));

var react_1 = require("react");

var useMountedState_1 = tslib_1.__importDefault(require("./useMountedState"));

var useSetState_1 = tslib_1.__importDefault(require("./useSetState"));

var useCopyToClipboard = function useCopyToClipboard() {
  var isMounted = useMountedState_1["default"]();

  var _a = useSetState_1["default"]({
    value: undefined,
    error: undefined,
    noUserInteraction: true
  }),
      state = _a[0],
      setState = _a[1];

  var copyToClipboard = react_1.useCallback(function (value) {
    try {
      if (process.env.NODE_ENV === 'development') {
        if (typeof value !== 'string') {
          console.error("Cannot copy typeof " + typeof value + " to clipboard, must be a string");
        }
      }

      var noUserInteraction = copy_to_clipboard_1["default"](value);

      if (!isMounted()) {
        return;
      }

      setState({
        value: value,
        error: undefined,
        noUserInteraction: noUserInteraction
      });
    } catch (error) {
      if (!isMounted()) {
        return;
      }

      setState({
        value: undefined,
        error: error,
        noUserInteraction: true
      });
    }
  }, []);
  return [state, copyToClipboard];
};

exports["default"] = useCopyToClipboard;